export const getFormatedDate = (dateStr) => {
  if (!dateStr) return ""

  let utcStr =
    dateStr.includes("Z") || dateStr.includes("+") ? dateStr : dateStr + "Z"

  const dateObj = new Date(utcStr)
  return dateObj.toLocaleString("he-IL", { timeZone: "Israel" })
}

export const getCurrentTimeUnixFormat = () => {
  const currentTime = new Date()
  const utcTimeUnixFormat = Math.floor(currentTime.getTime() / 1000)
  return utcTimeUnixFormat
}
